import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    pageLoader: {},
}

export const utilsSlice = createSlice({
    name: 'utils',
    initialState,
    reducers: {
        setPageLoader: (state, { payload }) => {
            let { page, flag } = payload
            state.pageLoader[page] = flag
        },
        clearPageLoader: (state) => {
            state.pageLoader = {}
        },
    },
})

// Action creators are generated for each case reducer function
export const { setPageLoader, clearPageLoader } = utilsSlice.actions

export default utilsSlice.reducer